import React, { Suspense, useState } from 'react';
import { Html } from '../components/3DHTML';
import { Scroll, ScrollControls, OrthographicCamera, Environment, useProgress } from '@react-three/drei';
import Objects from '../components/Objects';
import Scroller from "../components/Scroller";
import { Canvas } from '@react-three/fiber';
import styles from '../styles/home.module.css';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../components/SkillsModal';
import Loader from '../components/Loader';

const Home = () => {
    const navigate = useNavigate();
    const [visibleModal, setVisibleModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const { active, progress } = useProgress();

    const handleStateChange = (state) => {
        setVisibleModal(state.state);
        setModalType(state.type);
    }

    return (
        <>
        {active && <Loader progress={progress} />}
        <div style={{ display: active ? 'none' : 'block' }} className={styles.threedcontainer}>
        <Suspense fallback={null}>
            <Canvas>
            <OrthographicCamera
                makeDefault
                position={[0, 0, 10]}
                zoom={50}
            />
                <ScrollControls pages={3}>
                    <Scroll>
                        <Objects />
                    </Scroll>
                    <Scroll html>
                        <Html navigate={navigate} onStateChange={handleStateChange} />
                        <Scroller />
                    </Scroll>
                </ScrollControls>
                <Environment preset="city" />
            </Canvas>
        </Suspense>
        {visibleModal && <Modal onStateChange={handleStateChange} type={modalType} />}
        </div>
        </>
    )
};
  
export default Home;